// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComboPrices_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /so/combo_prices/remover.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ComboPrices_RemoverResponseDados {
so_combo_price_id: number
}

export type ComboPrices_RemoverResponse = ApiResponse<ComboPrices_RemoverResponseDados>;

registerResponseContract('ComboPrices_RemoverResponse', {
  so_combo_price_id: { type: 'number',  required: true },
})
